/**
 *
 * Avatar
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Avatar from 'react-avatar';




export const AvatarWrapper = styled.div`
  position: relative;
  border-radius: 50px;
  margin-left: ${p => p.marginLeft || '0'};
  margin-right: ${p => p.marginRight || '0'};
  z-index: ${p => p.zIndex || '1'};
  box-shadow: ${p => p.theme.boxShadow.one};
  padding: ${p => p.isBot ? '5px' : '0px'};
  ${p => p.isBot && `background: ${p.bgColor};`}
  height: ${p => `${parseInt(p.size)}px`}
  width: ${p => `${parseInt(p.size)}px`}
`;


export const InsentAvatar = ({isBot, img, name, marginLeft, marginRight, zIndex, size, bgColor,...props}) => {
  return (
    <AvatarWrapper isBot={isBot} marginLeft={marginLeft} marginRight={marginRight} zIndex={zIndex} bgColor={bgColor} size={size}>
      <Avatar src={img} name={name} size={size} round={true} />
    </AvatarWrapper>
  );
}

Avatar.propTypes = {
  img: PropTypes.string,
  isBot: PropTypes.boolean,
  name: PropTypes.string,
  marginLeft: PropTypes.string,
  marginRight: PropTypes.string,
  zIndex: PropTypes.string,
  size: PropTypes.string.isRequired,
  bgColor: PropTypes.string,
};

export default InsentAvatar;
